import { useStoreMap } from 'effector-react'
import { inspectionModel } from '~/entities/Inspection'
import { InspectionPhotoTypeEnum } from '~/shared/config/enums'
import { Gallery, mapPhotoToImage } from '~/shared/ui/Gallery'
import { EmptyPhotoTitle, Title, Wrapper } from './styled'

export function Photos() {
  const photos = useStoreMap(
    inspectionModel.$inspection,
    (inspections) => inspections?.getPhotos() || [],
  )

  const carPhotos = photos
    ?.filter((photo) => photo.type === InspectionPhotoTypeEnum.CAR)
    .map(mapPhotoToImage)

  const emptyPhoto = <EmptyPhotoTitle>Фото отсутствует</EmptyPhotoTitle>

  return (
    <Wrapper>
      <Title>Круговые фото</Title>

      {carPhotos?.length ? <Gallery images={carPhotos} /> : emptyPhoto}
    </Wrapper>
  )
}
